import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { ENVIRONMENTS } from '../../services/exports/Constants';
import { AVAILABLE_LANGUAGES } from '../../services/exports/Constants';
import { AvailableLanguageInterface } from '../../services/exports/Interfaces';
import classNames from 'classnames';

const LanguageSelector = (): JSX.Element => {
  const { i18n } = useTranslation();

  return import.meta.env.VITE_MODE !== ENVIRONMENTS.PROD ? (
    <div className="flex gap-x-2xs">
      {AVAILABLE_LANGUAGES?.map((item: AvailableLanguageInterface) => {
        const active = item?.language === i18n.language;

        return (
          <button
            key={item?.language}
            className={classNames('my-auto h-fit rounded p-2xs text-2xs', {
              'bg-brand-button-primary-background': active,
            })}
            onClick={() => i18next.changeLanguage(item?.language)}
          >
            <p
              className={classNames('font-medium text-xs uppercase', {
                'text-brand-button-primary-text': active,
              })}
            >
              {item?.language}
            </p>
          </button>
        );
      })}
    </div>
  ) : null;
};

export default LanguageSelector;
